<template>
  <section>
    <p>Initial bet size:</p>
    <section class="btn-group">
      <button
        class="btn btn-default"
        v-bind:class="{ active: initialBetSize === '1/2 pot' }"
        v-on:click="$emit('setInitialBetSize', '1/2 pot')"
      >
        1/2 pot
      </button>
      <button
        class="btn btn-default"
        v-bind:class="{ active: initialBetSize === '3/4 pot' }"
        v-on:click="$emit('setInitialBetSize', '3/4 pot')"
      >
        3/4 pot
      </button>
      <button
        class="btn btn-default"
        v-bind:class="{ active: initialBetSize === 'Full pot' }"
        v-on:click="$emit('setInitialBetSize', 'Full pot')"
      >
        Full pot
      </button>
    </section>
  </section>
</template>

<script>
export default {
  name: 'initial-bet-size-button-group',
  props: ['initialBetSize'],
};
</script>



// WEBPACK FOOTER //
// src/components/hit-calculator/five-card-hands-section/insights/initial-bet-size-button-group.vue